import {cancelCustomerOffer} from "@project/sdk/sales";
import {CancelCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function cancelCustomerOfferMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.cancelCustomerOffer,
    mutationFn: async (id: string) =>
      CancelCustomerOfferResponse.parse(await cancelCustomerOffer(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
